import { Preferences } from "@capacitor/preferences";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export default function usePreference<TOption extends string>(props: {
  id: string;
  options: TOption[] | readonly TOption[];
  defaultOption: TOption;
}) {
  const queryClient = useQueryClient();
  const { data: layout } = useQuery({
    queryKey: ["preference", props.id],
    queryFn: async () => {
      const { value } = await Preferences.get({ key: `preference:${props.id}` });
      return value as TOption | null;
    },
  });

  const { mutate: setLayout } = useMutation({
    mutationFn: async (layout: TOption) => {
      await Preferences.set({ key: `preference:${props.id}`, value: layout });
      await queryClient.invalidateQueries(["preference", props.id]);
    },
  });

  return [layout ?? props.defaultOption, setLayout] as const;
}
